import React, { useState } from 'react';

const Sixteenththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Emerald City */
            --primary: #059669;       /* Emerald 600 */
            --primary-dark: #064e3b;  /* Emerald 900 */
            --primary-light: #34d399; /* Emerald 400 */
            --accent: #a7f3d0;        /* Emerald 200 */
            --bg-body: #ecfdf5;       /* Emerald 50 */
            --bg-white: #ffffff;
            --text-dark: #064e3b;     
            --text-muted: #374151;    

            --font-head: 'Rubik', sans-serif;
            --font-body: 'Karla', sans-serif;

            --radius: 12px;
            --shadow: 0 4px 6px -1px rgba(5, 150, 105, 0.1), 0 2px 4px -1px rgba(5, 150, 105, 0.06);
        }

        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: var(--font-body); color: var(--text-dark); background-color: var(--bg-body); line-height: 1.6; }
        h1, h2, h3, h4, h5 { font-family: var(--font-head); color: var(--primary-dark); font-weight: 700; }
        a { text-decoration: none; color: inherit; transition: 0.3s; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
        .section { padding: 80px 0; }
        
        .btn { display: inline-block; padding: 12px 24px; background: var(--primary); color: white; border-radius: var(--radius); font-weight: 600; border: none; cursor: pointer; transition: 0.3s; }
        .btn:hover { background: var(--primary-dark); transform: translateY(-2px); }
        .btn-outline { display: inline-block; padding: 12px 24px; background: transparent; color: var(--primary); border: 2px solid var(--primary); border-radius: var(--radius); font-weight: 600; cursor: pointer;transition: 0.3s; }
        .btn-outline:hover { background: var(--primary); color: white; }

        .navbar { background: var(--bg-white); padding: 15px 0; position: sticky; top: 0; z-index: 1000; box-shadow: var(--shadow); }
        .navbar .container { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 1.5rem; font-weight: 700; color: var(--primary); text-transform: uppercase; letter-spacing: 1px; }
        .nav-links { display: flex; gap: 20px; }
        .nav-links a { font-weight: 500; color: var(--text-muted); }
        .nav-links a:hover { color: var(--primary); }

        .hero { background: linear-gradient(135deg, #064e3b 0%, #059669 100%); color: white; padding: 100px 0; text-align: center; border-bottom-left-radius: 50px; border-bottom-right-radius: 50px; }
        .hero h1 { color: white; font-size: 3.5rem; margin-bottom: 20px; }
        .hero p { opacity: 0.9; max-width: 600px; margin: 0 auto 30px; font-size: 1.2rem; }
        .hero .btn { background: white; color: var(--primary); }
        .hero .btn:hover { background: var(--accent); }

        .section-header { text-align: center; margin-bottom: 50px; }
        .section-tag { color: var(--primary); font-weight: 700; text-transform: uppercase; font-size: 0.85rem; letter-spacing: 1px; }
        .section-title { font-size: 2.5rem; margin-top: 10px; }

        .grid-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 30px; }
        .card { background: var(--bg-white); border-radius: var(--radius); padding: 30px; box-shadow: var(--shadow); transition: 0.3s; border: 1px solid #e5e7eb; }
        .card:hover { transform: translateY(-5px); border-color: var(--primary); }
        
        .icon-box { width: 60px; height: 60px; background: var(--bg-body); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 20px; font-size: 1.5rem; color: var(--primary); }
        .icon-box img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; }

        .product-img { height: 200px; border-radius: var(--radius); overflow: hidden; margin-bottom: 15px; }
        .product-img img { width: 100%; height: 100%; object-fit: cover; transition: 0.3s; }
        .card:hover .product-img img { transform: scale(1.05); }

        .footer { background: var(--primary-dark); color: white; padding: 60px 0 20px; margin-top: 50px; }
        .footer h4 { color: var(--accent); margin-bottom: 20px; }
        .footer a:hover { color: var(--accent); }
        
        @media (max-width: 768px) { .hero h1 { font-size: 2.5rem; } .nav-links { display: none; } }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Karla:wght@400;700&family=Rubik:wght@400;700&display=swap" rel="stylesheet" />

            {/* Nav */}
            <nav className="navbar">
                <div className="container">
                    <a href="#" className="brand">{get_data.service_name}</a>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                        <a href="#contact">Contact</a>
                    </div>
                </div>
            </nav>

            {/* Hero */}
            <header className="hero">
                <div className="container">
                    <h1>Natural Excellence</h1>
                    <p>Growth, stability, and freshness. We bring the best solutions to your life.</p>
                    <a href="#services" className="btn">Explore Now</a>
                </div>
            </header>
            
            {/* Services */}
            <section className="section" id="services">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Features</span>
                        <h2 className="section-title">Our Services</h2>
                    </div>
                    <div className="grid-cards">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="card" key={index}>
                                <div className="icon-box">
                                     {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} alt={item.name}/> : <span>☘</span>}
                                </div>
                                <h3>{item.name}</h3>
                                <p style={{color: 'var(--text-muted)', margin: '10px 0 20px'}}>{item.description || 'Details coming soon.'}</p>
                                <div style={{display: 'flex', gap: '10px'}}>
                                    <a href={`tel:${get_data.mobile}`} className="btn-outline" style={{padding: '8px 16px', fontSize: '0.9rem'}}>Call</a>
                                    <a href="#contact" className="btn" style={{padding: '8px 16px', fontSize: '0.9rem'}}>Enquiry</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            
             {/* Products */}
            <section className="section" id="products" style={{background: 'white'}}>
                 <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Shop</span>
                        <h2 className="section-title">Fresh Arrivals</h2>
                    </div>
                    <div className="grid-cards">
                         {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="card" key={index}>
                                <div className="product-img">
                                     <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} alt={item.service_name}/>
                                </div>
                                <h3>{item.service_name}</h3>
                                {item.price && <div style={{color: 'var(--primary)', fontWeight: 'bold', marginBottom: '10px'}}>₹{item.price}</div>}
                                <p style={{fontSize: '0.9rem', color: '#666', marginBottom: '15px'}}>{item.description}</p>
                                <button onClick={() => addToCart(item)} className="btn" style={{width: '100%'}}>Add to Cart</button>
                            </div>
                         ))}
                    </div>
                 </div>
            </section>

             {/* Footer */}
            <footer className="footer" id="contact">
                <div className="container">
                    <h2 style={{color: 'white', marginBottom: '10px'}}>{get_data.service_name}</h2>
                    <p style={{marginBottom: '30px', opacity: 0.8}}>{get_data.business_location_name} | {get_data.mobile}</p>
                    <div style={{display: 'flex', gap: '20px', fontSize: '0.9rem', opacity: 0.7}}>
                        &copy; {new Date().getFullYear()} {get_data.service_name}. All Rights Reserved.
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Sixteenththeme;
